import { useMutation } from "@tanstack/react-query";

import { apiGqlClient } from "~/libs/gql";
import { graphql } from "~/types/__generated/gql";
import {
	GetFileUploadUrlMutation,
	GetFileUploadUrlMutationVariables,
} from "~/types/__generated/gql/graphql";

const query = /* GraphQL */ `
	mutation GetFileUploadUrl(
		$type: FILE_UPLOAD_TYPE!
		$id: ObjectID!
		$extension: String!
		$mimeType: String!
	) {
		getFileUploadUrl(
			type: $type
			id: $id
			extension: $extension
			mimeType: $mimeType
		) {
			uploadUrl
			fileUrl
			filePath
		}
	}
`;

export type GetFileUploadUrlVariables = GetFileUploadUrlMutationVariables;
export type GetFileUploadUrlResults =
	GetFileUploadUrlMutation["getFileUploadUrl"];

export const useGetFileUploadUrl = () => {
	return useMutation({
		mutationFn: (variables: GetFileUploadUrlVariables) =>
			apiGqlClient
				.request(graphql(query), variables)
				.then((res) => res.getFileUploadUrl),
	});
};
